import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DocumentService {
  private documentLengthSubject = new BehaviorSubject<number>(0);
  private documentNameSubject = new BehaviorSubject<string>('');

  // Observables for components to subscribe to
  documentLength$ = this.documentLengthSubject.asObservable();
  documentName$ = this.documentNameSubject.asObservable();

  // Method to set document length and name
  setDocumentData(length: number, name: string) {
    this.documentLengthSubject.next(length);
    this.documentNameSubject.next(name);
  }
}
